//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 收款登记管理
// const registerManage = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/capitalCenter/receivablesManage/register/list.vue')),
//     'registerManage'
//   );
// 收款登记管理新建
// const addRegister = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/capitalCenter/receivablesManage/register/add.vue')),
//     'addRegister'
//   );
// 收款登记管理修改
// const editRegister = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/capitalCenter/receivablesManage/register/edit.vue')),
//     'editRegister'
//   );

// 收款认领管理
// const claimManage = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/capitalCenter/receivablesManage/claim/list.vue')),
//     'claimManage'
//   );
// 收款认领管理认领
// const claim = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/capitalCenter/receivablesManage/claim/claim.vue')),
//     'claim'
//   );
// 收款单管理
const receiptManage = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/receivablesManage/receipt/list.vue')),
    'receiptManage'
  );
// 收款单管理新建
const addReceipt = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/receivablesManage/receipt/add.vue')),
    'addReceipt'
  );
// 收款单管理修改
const editReceipt = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/receivablesManage/receipt/edit.vue')),
    'editReceipt'
  );
// 收款单管理查询
const detailsReceipt = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/receivablesManage/receipt/details.vue')),
    'detailsReceipt'
  );
const capitalRouter = {
  path: '/capital',
  component: index,
  children: [
    {
      path: 'registerManage',
      name: 'registerManage',
      component: () => import('@/pages/capitalCenter/receivablesManage/register/list.vue'),
      meta: {
        keepAlive: true,
        title: '收款登记管理',
      },
    },
    {
      path: 'addRegister',
      name: 'addRegister',
      component: () => import('@/pages/capitalCenter/receivablesManage/register/add.vue'),
      meta: {
        keepAlive: true,
        title: '新建收款登记',
      },
    },
    {
      path: 'editRegister',
      name: 'editRegister',
      component: () => import('@/pages/capitalCenter/receivablesManage/register/edit.vue'),
      meta: {
        keepAlive: true,
        title: '修改收款登记',
      },
    },
    {
      path: 'detailsRegister',
      name: 'detailsRegister',
      component: () => import('@/pages/capitalCenter/receivablesManage/register/details.vue'),
      meta: {
        keepAlive: true,
        title: '查看收款登记',
      },
    },
    {
      path: 'claimManage',
      name: 'claimManage',
      component: () => import('@/pages/capitalCenter/receivablesManage/claim/index.vue'),
      meta: {
        keepAlive: true,
        title: '收款认领管理',
      },
    },
    {
      path: 'claim',
      name: 'claim',
      component: () => import('@/pages/capitalCenter/receivablesManage/claim/claim.vue'),
      meta: {
        keepAlive: true,
        title: '收款认领',
      },
    },
    // 城矿
    {
      path: 'claimCK',
      name: 'claimCK',
      component: () => import('@/pages/capitalCenter/receivablesManage/claim/chengkuang/claim.vue'),
      meta: {
        keepAlive: true,
        title: '收款认领',
      },
    },
    {
      path: 'receiptManage',
      name: 'receiptManage',
      component: receiptManage,
      meta: {
        keepAlive: true,
        title: '收款单管理',
      },
    },
    {
      path: 'addReceipt',
      name: 'addReceipt',
      component: addReceipt,
      meta: {
        keepAlive: true,
        title: '新建收款单',
      },
    },
    {
      path: 'editReceipt',
      name: 'editReceipt',
      component: editReceipt,
      meta: {
        keepAlive: true,
        title: '修改收款单',
      },
    },
    {
      path: 'detailsReceipt',
      name: 'detailsReceipt',
      component: detailsReceipt,
      meta: {
        keepAlive: true,
        title: '查看收款单',
      },
    },
  ],
};
export default capitalRouter;
